import { useEffect, useState } from 'react';

import Button from 'components/button';
import Modal from 'components/modal';
import theme from 'styles/theme';

import HappyLisa from 'assets/videos/happyLisa.webm';
import { makeCheckRescheduleEligibilityUseCase } from 'shared/domain/useCases';
import { useLocale, useNavigation } from 'shared/presentation/contexts';

import { ModalWrapper, TitleModal } from './styles';

interface IModalRescheduleProps {
  openModal: boolean;
  closeModal(): void;
  scheduleId: number;
  items: Record<string, unknown>[];
}

const ModalReschedule = ({
  openModal,
  closeModal,
  scheduleId,
  items,
}: IModalRescheduleProps) => {
  const navigation = useNavigation();
  const { t } = useLocale('translations');
  const [checkingEligibility, setCheckingEligibility] = useState(false);
  const [notEligibleReason, setNotEligibleReason] = useState<string | null>(
    null,
  );

  useEffect(() => {
    if (openModal) {
      setNotEligibleReason(null);
    }
  }, [openModal]);

  const reSchedule = async (): Promise<void> => {
    if (checkingEligibility) {
      return;
    }

    setCheckingEligibility(true);

    try {
      const eligibility = await makeCheckRescheduleEligibilityUseCase().execute(
        { scheduleId },
      );

      if (eligibility?.eligible === false) {
        setNotEligibleReason(
          eligibility.reason || t('pages.schedules.modal.notEligibleFallback'),
        );
        return;
      }

      navigation.push(`/schedules`, {
        id: scheduleId,
        items: JSON.stringify(items.map(item => item.name)),
      });
    } catch {
      setNotEligibleReason(t('pages.schedules.modal.notEligibleFallback'));
    } finally {
      setCheckingEligibility(false);
    }
  };

  return (
    <Modal open={openModal} onClose={closeModal}>
      <>
        <ModalWrapper>
          <video src={HappyLisa} height="100" width="100" autoPlay loop muted />
          {notEligibleReason ? (
            <TitleModal>{notEligibleReason}</TitleModal>
          ) : (
            <>
              <TitleModal>{t('pages.schedules.modal.reschedule')}</TitleModal>
              <Button
                color={theme.colors.white}
                background={theme.colors.primary}
                onClick={() => reSchedule()}
              >
                {t('pages.schedules.card.reschedule')}
              </Button>
            </>
          )}
        </ModalWrapper>
      </>
    </Modal>
  );
};

export default ModalReschedule;
